import { simpleClient } from 'services/apiGatewayClient';
import { Integration, IntegrationConfig } from '../context/IntegrationsState';

const client = simpleClient<Integration>();

export async function getIntegrations(url: string) {
  return await client.get(url);
}

export async function postIntegration(url: string, object: Integration) {
  return await client.post(url, object);
}

export async function patchIntegration(url: string, object: Integration) {
  return await client.patch(url, object);
}

export async function patchConfig(url: string, config: IntegrationConfig) {
  return await client.patch(url, config);
}

export async function updateConfig(url: string, integration: Integration) {
  return await client.put(url, integration);
}

export async function getEnrichments(url: string) {
  return await client.getCollection(url);
}

export async function deleteIntegration(url: string) {
  return await client.delete(url);
}
